import styled from 'styled-components';

import {FieldMargin} from '../../_old/FieldHelpers/FieldContainers';
import {FloatingList} from '../../_old/styled/internals';

type ResultsListProps = {
  children: React.ReactNode;
};
export function ResultsList(props: ResultsListProps): React.JSX.Element {
  return <FloatingList.List role="listbox">{props.children}</FloatingList.List>;
}

type SearchContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode;
  className?: string;
  onBlur?: () => void;
};
export function SearchContainer(
  props: SearchContainerProps
): React.JSX.Element {
  return (
    <Container
      role="combobox"
      className={props.className}

      onBlurCapture={props.onBlur}
    >
      {props.children}
    </Container>
  );
}
const Container = styled(FieldMargin)`
  position: relative;
`;
